import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconOrdering(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M7.293 10.293a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L12 13.586l-3.293-3.293a1 1 0 0 0-1.414 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
